import { Suspense } from "react"
import { useTranslation } from "react-i18next"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { DashboardContainer } from "@/components/layout/dashboard-container"
import { Header } from "@/components/layout/header"
import { SubscriptionsFilterForm } from "@/components/subscriptions/filter-form"
import { SubscriptionsTable } from "@/components/subscriptions/table"
import { FRONTEND_ROUTES } from "@/constants"

export function SubscriptionsPage() {
  const { t } = useTranslation()

  return (
    <Suspense fallback={<div>{t("common.loading")}</div>}>
      <DashboardContainer>
        <Header>
          <AppBreadcrumb
            links={[
              {
                href: FRONTEND_ROUTES.DASHBOARD.href,
                label: t("sidebar.dashboard"),
              },
              {
                label: t("sidebar.subscriptions"),
              },
            ]}
          />
        </Header>
        <section className="flex flex-1 flex-col gap-4 overflow-x-hidden p-4 @container">
          <div className="flex items-center justify-between">
            <h1 className="page-title">
              {t("pages.subscriptions.title")}
            </h1>
          </div>
          <SubscriptionsFilterForm />
          <SubscriptionsTable />
        </section>
      </DashboardContainer>
    </Suspense>
  )
}
